import intendCar from '../../apis/intendcar.api';
let getIntendRedPacketPromise = null;
export default {
  state: {
    intendRedPacket: null,
  },
  mutations: {
    setIntendRedPacket(state, intendRedPacket) {
      state.intendRedPacket = intendRedPacket;
    },
  },
  getters: {
    intendRedPacket: (state) => state.intendRedPacket,
    hasRedPacket: (state) =>
      !!(state.intendRedPacket && state.intendRedPacket.promotionId),
  },
  actions: {
    getIntendRedpacket({ state, commit }, { dealerId, personalizedPush }) {
      if (state.intendRedPacket) {
        return Promise.resolve(state.intendRedPacket);
      }
      if (getIntendRedPacketPromise) {
        return getIntendRedPacketPromise;
      }
      getIntendRedPacketPromise = intendCar
        .getRecommendRedPacket({ dealerId, personalizedPush })
        .then(function (intendRedPacket) {
          console.log({
            intendRedPacket,
          });
          commit('setIntendRedPacket', intendRedPacket);
          return Promise.resolve(intendRedPacket);
        });
      return getIntendRedPacketPromise;
    },
  },
  namespaced: true,
};
